(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-page-secret-sale"]) return;
  try {
    
  if (!customElements.get('secret-sale-page')) {
    customElements.define('secret-sale-page', class extends HTMLElement {
      connectedCallback() {
        this.startTime = Number(this.dataset.startTimeMs);
        this.endTime = Number(this.dataset.endTimeMs);
        this.designMode = this.dataset.designMode === 'true';
        this.overlay = this.querySelector('[data-ended-overlay]');
        this.days = this.querySelector('[data-days]');
        this.hours = this.querySelector('[data-hours]');
        this.minutes = this.querySelector('[data-minutes]');
        this.seconds = this.querySelector('[data-seconds]');
        this.milliseconds = this.querySelector('[data-milliseconds]');
        this.accessibleRemaining = this.querySelector('[data-accessible-remaining]');
        this.countdownHeading = this.querySelector('[data-countdown-heading]');
        this.copyButtons = this.querySelectorAll('[data-copy-coupon]');
        this.handleCouponCopy = this.handleCouponCopy.bind(this);
        this.copyButtons.forEach((button) => button.addEventListener('click', this.handleCouponCopy));

        const now = Date.now();
        if (!Number.isFinite(this.endTime) || this.endTime <= 0) return;

        this.targetTime = Number.isFinite(this.startTime) && this.startTime > now
          ? this.startTime
          : this.endTime;
        this.lastAccessibleSecond = null;
        this.tick = this.tick.bind(this);
        this.frame = requestAnimationFrame(this.tick);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.copyButtons.forEach((button) => {
          button.removeEventListener('click', this.handleCouponCopy);
          clearTimeout(button.copyResetTimer);
        });
      }

      async handleCouponCopy(event) {
        const button = event.currentTarget;
        const couponCode = button.dataset.couponCode;
        if (!couponCode) return;

        try {
          await navigator.clipboard.writeText(couponCode);
        } catch (error) {
          const input = document.createElement('textarea');
          input.value = couponCode;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        }

        button.textContent = button.dataset.copiedLabel;
        clearTimeout(button.copyResetTimer);
        button.copyResetTimer = setTimeout(() => {
          button.textContent = button.dataset.copyLabel;
        }, 2000);
      }

      tick() {
        const remaining = Math.max(0, this.targetTime - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const milliseconds = Math.floor(remaining % 1000);

        if (this.days) this.days.textContent = String(days).padStart(2, '0');
        if (this.hours) this.hours.textContent = String(hours).padStart(2, '0');
        if (this.minutes) this.minutes.textContent = String(minutes).padStart(2, '0');
        if (this.seconds) this.seconds.textContent = String(seconds).padStart(2, '0');
        if (this.milliseconds) this.milliseconds.textContent = String(milliseconds).padStart(3, '0');

        if (this.accessibleRemaining && totalSeconds !== this.lastAccessibleSecond) {
          this.accessibleRemaining.textContent = `${days}${this.dataset.daysLabel} ${hours}${this.dataset.hoursLabel} ${minutes}${this.dataset.minutesLabel} ${seconds}${this.dataset.secondsLabel}`;
          this.lastAccessibleSecond = totalSeconds;
        }

        if (remaining <= 0) {
          if (this.targetTime === this.startTime && this.endTime > Date.now()) {
            this.targetTime = this.endTime;
            this.lastAccessibleSecond = null;
            if (this.countdownHeading) this.countdownHeading.textContent = this.dataset.endHeading;
            const countdown = this.countdownHeading?.closest('[role="timer"]');
            if (countdown) countdown.setAttribute('aria-label', this.dataset.endHeading);
            this.frame = requestAnimationFrame(this.tick);
            return;
          }
          this.endSale();
          return;
        }

        this.frame = requestAnimationFrame(this.tick);
      }

      endSale() {
        if (this.designMode || !this.overlay) return;
        this.overlay.hidden = false;
        document.documentElement.classList.add('secret-sale-ended');
        this.overlay.focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
